import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { ButtonWithIcon } from '@oy/uidesktop';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { useEnv, useProductActiveV2, useTranslate } from 'src/hooks';

const InternationalRemitListActionButton = () => {
  const { getTranslation } = useTranslate();
  const { isProdEnv } = useEnv();
  const { checkActive } = useProductActiveV2();

  const disabledButton = () => {
    return isProdEnv && !checkActive('INTERNATIONAL_TRANSFER');
  };

  return (
    <div id="coachList5">
      <Link
        id="btnCreateInterationalTransfer"
        onClick={() => {
          AnalyticsManager.instance().track(AnalyticsEvent.inter_remit_create);
        }}
        to={'/disbursement/create-international-remittance-transaction'}
      >
        <ButtonWithIcon
          data-tooltip-id="create-international-transfer-disabled-tooltip"
          data-tooltip-content={
            disabledButton()
              ? getTranslation('claimFund_disabledCreateButtonTooltip')
              : undefined
          }
          data-tooltip-place="bottom"
          iconName="add"
          disabled={disabledButton()}
        >
          {getTranslation('common_createNewTransaction')}
        </ButtonWithIcon>
      </Link>
      <Tooltip
        place="bottom"
        style={{
          zIndex: 9999,
          fontSize: '12px',
          maxWidth: '250px',
        }}
        id="create-international-transfer-disabled-tooltip"
      />
    </div>
  );
};

export default InternationalRemitListActionButton;
